module.exports = __webpack_public_path__ + "img/b2b.b2bd29a1.png";